import { z } from 'zod';
import {
    type NodeSocketCfg,
    baseNodeCfgSchema,
} from './base-node';

export const materialDisassemblyNodeCfgSchema = baseNodeCfgSchema.extend({
    kind: z.literal('materialDisassembly'),
    controlValues: z.object({
        // materialsToDisassemble: z.array(z.string()).min(1), //TODO: reimplement with dynamic number of inputs 
        reason: z.string().nullable(),
    }),
});
export interface MaterialDisassemblyNodeCfgSchema extends z.infer<typeof materialDisassemblyNodeCfgSchema> {}

export const materialDisassemblyNodeCfg = {
    controlSockets: {
        inputs: () => ({
            trigger: 'event',
        }),
        outputs: () => ({
            next: 'event',
        }),
    },
    dataSockets: {
        outputs: () => ({}),
        inputs: (): Record<('material1Id' | 'material2Id'), 'string'> => {
            // return Object.fromEntries(cfg.controlValues.materialsToDisassemble.map((materialId) => [ materialId, 'string' ])); //TODO: reimplement with dynamic number of inputs 
            return {
                material1Id: 'string',
                material2Id: 'string',
            };
        },
    },
} satisfies NodeSocketCfg<MaterialDisassemblyNodeCfgSchema>;
